<template>
  <div class="row">
    <div class="col-md-3">
      <form class="needs-validation" ref="form" id="form">
        <div class="form-group">
          <label class="mb-0" for="Operator">Operator: </label>
          <select class="form-control" v-model="operator" required>
            <option
              v-for="operator in operators"
              :key="operator.id"
              :value="operator.id"
            >
              {{ operator.username }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label class="mb-0" for="GlassBatch">Glas Batch: </label>
          <input
            type="text"
            class="form-control"
            v-model="glassBatch"
            id="GlassBatch"
            required
          />
        </div>

        <div class="mb-3 form-group">
          <label class="mb-0" for="BatchProductionDate">{{
            datePickerLabel
          }}</label>
          <VueDatePicker
            class="b-form-datepicker"
            v-model="batchProductionDate"
            :enable-time-picker="false"
            required
            >{{ batchProductionDate }}</VueDatePicker
          >
        </div>

        <div class="mb-2 form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="isHardeningPass"
            value=""
            id="isHardeningPass"
          />
          <label class="form-check-label" for="isHardeningPass">
            Glas ist gehärtet (bitte zuerst testen)
          </label>
        </div>

        <div class="mb-1 form-label">
          <label class="form-check-label">Ist die Palette bereits offen?</label>
        </div>

        <div class="mb-1 form-check">
          <input
            class="form-check-input"
            type="radio"
            name="isPaletteOpened"
            id="radio2True"
            v-model="isPaletteOpened"
            v-bind:value="true"
          />
          <label>Ja</label>
        </div>
        <div class="mb-3 form-check">
          <input
            class="form-check-input"
            type="radio"
            name="isPaletteOpened"
            id="radio2False"
            v-model="isPaletteOpened"
            v-bind:value="false"
          />
          <label>Nein</label>
        </div>

        <div class="mb-1 form-label">
          <label class="form-check-label">Glastyp</label>
        </div>

        <div
          class="mb-1 form-check"
          v-for="(glassType, id) in glassTypes"
          :key="id"
        >
          <input
            class="form-check-input"
            type="radio"
            name="glassTypes"
            :id="'radio1' + id"
            v-model="chosenGlassType"
            :value="glassType"
            @change="disableInputField"
          />
          <label class="form-check-label" :for="'radio1' + id">
            {{ glassType.name }}
          </label>
        </div>

        <div class="mb-3 form-check">
          <input
            class="form-check-input"
            type="radio"
            name="glassTypes"
            id="radioOther1"
            value="true"
            @change="enableInputField"
          />
          <label class="form-check-label" for="radioOther1"> andere </label>
          <input
            class="form-control"
            type="text"
            name="glassType"
            v-model="chosenGlassType"
            id="inputField"
            hidden
          />
        </div>

        <button type="button" class="btn btn-primary mb-3" @click="submit()">
          Speichern
        </button>
      </form>

      <transition name="alert">
        <div
          class="alert alert-success mt-1"
          role="alert"
          v-if="triggerSuccess"
        >
          Der Eintrag wurde gespeichert!
        </div>
      </transition>

      <transition name="alert">
        <div class="alert alert-danger mt-1" role="alert" v-if="triggerError">
          Eintrag konnte nicht gespeichert werden!
        </div>
      </transition>

      <transition name="alert">
        <div
          class="alert alert-warning mt-1"
          role="alert"
          v-if="triggerWarning"
        >
          Bitte füllen Sie alle Felder aus!
        </div>
      </transition>

      <transition name="alert">
        <div class="alert alert-warning mt-1" role="alert" v-if="triggerAbort">
          Vorgang abgebrochen!
        </div>
      </transition>
    </div>

    <div class="col-md-9">
      <GlassLoaderTable :url="props.tableUrl" :key="componentKey" />
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, defineProps, watch } from "vue";
import VueDatePicker from "@vuepic/vue-datepicker";
import GlassLoaderTable from "@/components/glassloader/GlassLoaderTable.vue";
import moment from "moment-timezone";
import { instance as axios } from "@/services/axios";

const props = defineProps({
  glassType: {
    type: String,
    required: true,
  },
  tableUrl: {
    type: String,
    required: true,
  },
});

const componentKey = ref(0);
const stationId = props.glassType === "frontglass" ? 54 : 19;

let operator = ref();
let chosenGlassType = ref();
let glassBatch = ref("");
let isHardeningPass = ref(false);
let isPaletteOpened = ref(false);
let batchProductionDate = ref();
let datePickerLabel = ref("Glas Produktionsdatum: ");

const operators = ref([]);
const glassTypes = ref([]);

let triggerSuccess = ref(false);
let triggerError = ref(false);
let triggerWarning = ref(false);
let triggerAbort = ref(false);

onMounted(() => {
  axios
    .get("/User/GetUsersByJobtype/2")
    .then(({ data }) => {
      operators.value = data
        .map(({ id, username }) => ({ id, username }))
        .sort((a, b) => a.username.localeCompare(b.username));
    })
    .catch((error) => console.log(error.message));

  fetchMaterials();
});

watch(glassBatch, (newValue) => {
  if (newValue && newValue.includes("$")) {
    glassBatch.value = newValue.slice(newValue.indexOf("$") + 1);
  }
});
document.addEventListener("keydown", (event) => {
  if (event.key === "$") {
    glassBatch.value = "";
  }
});

function enableInputField() {
  chosenGlassType.value = null;
  document.getElementById("inputField").hidden = false;
}

function disableInputField() {
  document.getElementById("inputField").hidden = true;
}

function fetchMaterials() {
  axios
    .get("/Material/GetAllGlassTypes")
    .then(({ data }) => {
      glassTypes.value = data
        .filter(
          ({ standardGlass }) =>
            standardGlass === 1 || standardGlass === stationId
        )
        .map(({ id, name, standardGlass }) => ({ id, name, standardGlass }));
    })
    .catch((error) => console.log(error.message));
}

function resetForm() {
  operator.value = null;
  chosenGlassType.value = null;
  glassBatch.value = "";
  isHardeningPass.value = false;
  isPaletteOpened.value = false;
  batchProductionDate.value = null;
  componentKey.value += 1;
  fetchMaterials();
  disableInputField();
  document.getElementById("radioOther1").checked = false;
}

async function submit() {
  //checks form validity, because standard form validation doesn't work due to incompatibilities of bootstrap/vue3
  if (
    !document.getElementById("form").checkValidity() ||
    chosenGlassType.value == null ||
    batchProductionDate.value == null
  ) {
    //warning alert
    triggerWarning.value = true;
    setTimeout(() => (triggerWarning.value = false), 5000);
    return;
  }

  const currentDate = moment().tz("Europe/Zurich").format();
  let batchProductionDateConverted = new Date(batchProductionDate.value);
  if (chosenGlassType.value.standardfoil === 18) {
    batchProductionDateConverted.setMonth(
      batchProductionDateConverted.getMonth() + 12
    );
  }
  batchProductionDateConverted = batchProductionDateConverted
    .toISOString()
    .split("T", 1)
    .toString();

  let jsonObject = {
    operatorid: operator.value,
    stationid: stationId,
    dateInProduction: currentDate,
    glasstype: props.glassType,
    glassbatch: glassBatch.value,
    productiondate: new Date(batchProductionDateConverted),
    ispaletteopened: isPaletteOpened.value,
    ishardeningpass: isHardeningPass.value,
    glassColor: null,
    name: chosenGlassType.value.name
      ? chosenGlassType.value.name
      : chosenGlassType.value,
    standardglass: chosenGlassType.value.standardglass
      ? chosenGlassType.value.standardglass
      : stationId,
  };
  console.log(jsonObject);
  try {
    //change post request
    await axios.post("/Material/AddMaterialGlass", jsonObject);
  } catch (e) {
    console.log(e.message);

    triggerError.value = true;
    setTimeout(() => (triggerError.value = false), 5000);
    resetForm();
    return;
  }
  //success alert
  triggerSuccess.value = true;
  setTimeout(() => (triggerSuccess.value = false), 5000);
  resetForm();
}
</script>

<style>
.alert-enter-active,
.alert-leave-active,
.modal-enter-active {
  transition: opacity 0.5s ease;
}
.alert-enter-from,
.alert-leave-to,
.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

input[type="radio"] {
  transform: scale(1.3);
}
input[type="checkbox"] {
  transform: scale(1.2);
}
</style>
